import userQueries from '@apis/queries/userQueries';
import { useQuery } from '@tanstack/react-query';

function useAssets() {
    const { data } = useQuery({
        ...userQueries.assets(),
        retry: 1,
    });
    return { data };
}

export default useAssets;
